import ICommission from '../interfaces/ICommission';
import Api from './Api';

const BASE_PATH = '/v3';

export const getServicesCommissions = async (): Promise<ICommission[]> => {
  const { commissions } = await Api.get(`${BASE_PATH}/services_commissions`);
  return commissions;
};
